import remoteConfig from '@react-native-firebase/remote-config';
import { Telemetry } from 'app/services/telemetry/Telemetry';

const MINIMUM_FETCH_INTERVAL_MS = 3_600_000;

class RemoteConfigManager {
  private initialized = false;

  async init() {
    if (this.initialized) return;

    try {
      await remoteConfig().setConfigSettings({
        minimumFetchIntervalMillis: MINIMUM_FETCH_INTERVAL_MS,
      });
      await remoteConfig().fetchAndActivate();
      this.initialized = true;
    } catch (error) {
      Telemetry.error(error, {
        event: 'remote_config.init_error',
        domain: 'infra',
      });
    }
  }

  getString(key: string, fallback: string): string {
    const value = remoteConfig().getValue(key).asString();
    return value || fallback;
  }
}

export const remoteConfigManager = new RemoteConfigManager();
